export enum TabValues {
    AddOrEditAttributes = "ADD_OR_EDIT_ATTRIBUTES",
    ImportAttributes = "IMPORT_ATTRIBUTES",
}

export enum ExportMode {
    Excel = "EXCEL",
    Csv = "CSV",
}
